import {TUTORIAL_CHAPTER_1} from './chapter1';
import {TUTORIAL_CHAPTER_2} from './chapter2';
import {TUTORIAL_CHAPTER_3} from './chapter3';
import {selectTutorialState} from '../../redux/reducers/privateStateReducer/selectors';
import {checkIfKnownGroundBackground, getRandomGroundBackground} from '../groundBackgrounds';
import {TUTORIAL_BOT_ACTION_INTERVAL_MS} from '../../utils/bots/botConfig';

/**
 * Кампания обучения. Порядок массива = порядок миссий в списке и порядок
 * последовательной разблокировки (глава N доступна после главы N-1).
 *
 * Формат главы — см. док-комментарий в chapter1.js. Сценарии редактируются
 * прямо в конфигах глав, движок (middleware/скрипт бота/панель задач) читает
 * их только отсюда.
 */
export const TUTORIAL_CHAPTERS = [
  TUTORIAL_CHAPTER_1,
  TUTORIAL_CHAPTER_2,
  TUTORIAL_CHAPTER_3,
];

export const getTutorialChapter = (chapterId) =>
  TUTORIAL_CHAPTERS.find((chapter) => chapter.id === chapterId) || null;

/**
 * Подложка поля главы: у каждой главы она своя и постоянная (chapter.groundBackground).
 * Случайная — только запасной вариант для главы, где подложка не задана или
 * снята с раздачи, чтобы поле не осталось без картинки
 */
export const getTutorialChapterGroundBackground = (chapter) => (
  checkIfKnownGroundBackground(chapter?.groundBackground)
    ? chapter.groundBackground
    : getRandomGroundBackground()
);

/**
 * Пауза между действиями скриптованного бота в главе (мс). Общий темп обучения
 * рассчитан на то, чтобы игрок успевал разглядеть ход противника, но глава
 * может задать свой: botActionIntervalMs в конфиге главы
 */
export const getTutorialBotActionIntervalMs = (chapterId) => (
  getTutorialChapter(chapterId)?.botActionIntervalMs ?? TUTORIAL_BOT_ACTION_INTERVAL_MS
);

/**
 * Активный контекст обучения из состояния: глава, текущий шаг, завершенность.
 * Единая точка чтения для middleware, панели задач, стрелок и хоста модалок.
 */
export const getActiveTutorialContext = (state) => {
  const tutorialState = selectTutorialState(state);
  if (!tutorialState?.chapterId) {
    return {chapter: null, step: null, stepIndex: 0, isCompleted: false};
  }
  const chapter = getTutorialChapter(tutorialState.chapterId);
  if (!chapter) {
    return {chapter: null, step: null, stepIndex: 0, isCompleted: false};
  }
  return {
    chapter,
    step: chapter.steps[tutorialState.stepIndex] || null,
    stepIndex: tutorialState.stepIndex,
    isCompleted: tutorialState.isChapterCompleted,
  };
};

/**
 * Все ли главы кампании пройдены (для превращения кнопки «Обучение» в
 * «Сюжетная кампания» и скрытия бейджа)
 */
export const checkIfAllTutorialChaptersCompleted = (completedChapterIds) =>
  TUTORIAL_CHAPTERS.every((chapter) => (completedChapterIds || []).includes(chapter.id));
